import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { BasketballAverageStatType } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import { statLabels } from '@sorare/core/src/lib/scoring';

import { nbaAverageStats } from 'lib/scoutingCenter';

const nbaSortableStats = nbaAverageStats.map(stat => ({
  value: stat,
  label: (
    <FormattedMessage
      {...statLabels[stat.toLowerCase() as keyof typeof statLabels]}
    />
  ),
}));

const CapitalizeFirstLetter = styled.span`
  &::first-letter {
    text-transform: uppercase;
  }
`;

type Props = {
  stats: BasketballAverageStatType[];
  onChange: (sort: BasketballAverageStatType[]) => void;
};

export const NBAStats = ({ stats, onChange }: Props) => {
  return (
    <Vertical>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage {...scoutingCenter.statistics} />
      </LabelM>
      {nbaSortableStats.map(({ value, label }) => (
        <Switch
          key={value}
          label={
            <Horizontal>
              <CapitalizeFirstLetter>{label}</CapitalizeFirstLetter>
            </Horizontal>
          }
          checked={stats.some(v => v === value)}
          onChange={() =>
            onChange(
              stats.includes(value)
                ? stats.filter(v => v !== value)
                : [...stats, value]
            )
          }
        />
      ))}
    </Vertical>
  );
};
